<template>
	<div class="non-bind-mask">
		<div :class="className" class="svip">
			<img src="@/assets/qualificationQuery/svip_icon.png" alt="" />
			<p>{{ messageInfo }}</p>
			<router-link to="/member-benefits" target="_blank">
				去开通
				<i class="el-icon-arrow-right"></i>
			</router-link>
		</div>
	</div>
</template>

<script>
	// 未绑定超级会员
	export default {
		name: 'NonbindSVip',
		components: {},
		props: {
			// 样式类名
			className: {
				type: String,
				default: 'mask-content'
			},
			// 提示信息
			messageInfo: {
				type: String,
				default: '开通超级会员即可查看'
			}
		},
		data() {
			return {}
		},
		computed: {},
		watch: {},
		created() {},
		mounted() {},
		methods: {}
	}
</script>

<style lang="scss" scoped></style>
